// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-925bf80a]:before{content:\"\";position:absolute;background:#2ba66b;width:100%;height:4px;bottom:-11px}.active[data-v-925bf80a]{position:relative}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
